/**
 * Root tour overlay – renders all tour UI (Quick Tour + Setup Tour).
 * Must be placed inside BrowserRouter, TourProvider, and SetupTourProvider.
 */

import { TourSpotlight } from './TourSpotlight';
import { TourWelcomeModal, TourCompletionModal } from './TourModals';
import { SetupTourSpotlight } from './SetupTourSpotlight';
import { SetupTourCompletionModal } from './SetupTourModals';

export function TourOverlay() {
  return (
    <>
      <TourWelcomeModal />
      <TourSpotlight />
      <TourCompletionModal />
      <SetupTourSpotlight />
      <SetupTourCompletionModal />
    </>
  );
}
